import { API_LOADING, ERROR_DISPLAY } from "../actionTypes";
import { globalInitialState } from "../initialState";

export const globalReducer = (state = globalInitialState, action) => {
  switch (action.type) {
    case API_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case ERROR_DISPLAY:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};
